<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="dashboard_widget.widget_id && dashboard_widget.widget_id > 0"
                                @invoke-method="dbGetDashboardWidget(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="dashboard_widget.widget_id && dashboard_widget.widget_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('dashboard_widgets.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in dashboard_widget_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != dashboard_widget.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('dashboard_widgets.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_dashboard_widget.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'dashboard_widgets' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="dashboard_widget.status" class="ribbon ribbon-top-right" :class="`ribbon-${dashboard_widget.status_class}`"><span class="ribbon-span">{{ dashboard_widget.status }}</span></div>
                        <v-form ref="formDashboardWidget">
							<v-flex xs12>
								<v-text-field
									v-focus="dashboard_widget_dialog"
									v-model="dashboard_widget.name"
									:label="`${$t('lang.name')} *`"
									:counter="showCounter(dashboard_widget.name, 'dashboard_widgets.name')"
									:rules="ifValid('dashboard_widgets.name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="dashboard_widget.name_alias"
									:label="$t('lang.name_alias')"
									:counter="showCounter(dashboard_widget.name_alias, 'dashboard_widgets.name_alias')"
									:rules="ifValid('dashboard_widgets.name_alias')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="dashboard_widget.column_span"
									:label="`${$t('lang.column_span')} *`"
									:counter="showCounter(dashboard_widget.column_span, 'dashboard_widgets.column_span')"
									:rules="ifValid('dashboard_widgets.column_span')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="dashboard_widget.permission"
									:label="$t('lang.permission')"
									:counter="showCounter(dashboard_widget.permission, 'dashboard_widgets.permission')"
									:rules="ifValid('dashboard_widgets.permission')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-switch
									v-model="dashboard_widget.active"
									:label="`${$t('lang.active')} *`"
									:rules="ifValid('dashboard_widgets.active')"
								></v-switch>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'dashboard_widgets' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveDashboardWidgets">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_dashboard_widget"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_dashboard_widget')"
                :message="$t('lang.delete_dashboard_widget_confirm')"
                @onConfirm="deleteDashboardWidgets()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_dashboard_widget_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteDashboardWidgetDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            dashboard_widget: { },
            file_name: "",
            dbGetDashboardWidget: _.debounce(this.getDashboardWidget, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchDashboardWidget", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.dashboard_widget) {
                        this.dashboard_widget = this.assignObj2(data.dashboard_widget, this.rules_dashboard_widgets);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=dashboard_widget_status&sort_by=2",
                            method: "get",
                            stateProperty: "dashboard_widget_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "dashboard_widgets", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchDashboardWidget", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.dashboard_widget) {
                        next((vm) => {
                            vm.dashboard_widget = vm.assignObj2(data.dashboard_widget, vm.rules_dashboard_widgets);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=dashboard_widget_status&sort_by=2",
                                method: "get",
                                stateProperty: "dashboard_widget_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard_widgets", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=dashboard_widget_status&sort_by=2",
            method: "get",
            stateProperty: "dashboard_widget_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_dashboard_widgets: (state) => state.dashboard_widgets.rules_dashboard_widgets,
            dashboard_widget_status_options: (state) => state.settings.dashboard_widget_status_options,
            dashboard_widgets: (state) => state.dashboard_widgets.dashboard_widgets,
            selectedDashboardWidget: (state) => state.dashboard_widgets.selectedDashboardWidget,

        }),
    },
    methods: {
        ...mapActions([
            "fetchDashboardWidget",
            "saveDashboardWidget",
            "deleteDashboardWidget",
            "printDashboardWidget",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getDashboardWidget(pg_refresh = false) {
            this.startLoader();

            this.fetchDashboardWidget({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.dashboard_widget) {
                    this.dashboard_widget = this.assignObj2(data.dashboard_widget, this.rules_dashboard_widgets);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printDashboardWidget({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.dashboard_widget) {
                    if (this.dev_mode) {
                        this.file_name = data.dashboard_widget.file_name;
                    } else {
                        this.$refs.print.printReport(data.dashboard_widget.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveDashboardWidgets() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formDashboardWidget")) {
                    let body = this.prepForm(this.dashboard_widget, this.rules_dashboard_widgets);

                    this.saveDashboardWidget({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.dashboard_widget) {
                            this.$router.push({ name: "dashboard_widget", params: { id: data.dashboard_widget.widget_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { widget_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveDashboardWidgets({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.dashboard_widget) {
                    this.dashboard_widget = this.assignObj2(data.dashboard_widget, this.rules_dashboard_widgets);
                }
            });
        },
        deleteDashboardWidgets() {
            this.deleteDashboardWidget({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "dashboard_widgets" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchDashboardWidget({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.dashboard_widget) {
                        this.dashboard_widget = this.assignObj2(data.dashboard_widget, this.rules_dashboard_widgets);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }


        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
